import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export function useTopCouponsRoute(coupons) {
    const { couponId } = useParams();
    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        if (!couponId || !coupons || coupons.length === 0) return;

        const coupon = coupons.find(c => String(c.id) === couponId);
        if (coupon) {
            setSelectedCoupon(coupon);
            setIsModalOpen(true);
        }
    }, [couponId, coupons]);

    const openCoupon = (coupon) => {
        if (!coupon) return;

        // Atualiza a URL sem triggerar re-render, preservando os filtros/página
        const newUrl = `/top-cupons/${coupon.id}${window.location.search}`;
        window.history.replaceState(null, '', newUrl);

        setSelectedCoupon(coupon);
        setIsModalOpen(true);
    };

    const closeCoupon = () => {
        const newUrl = `/top-cupons${window.location.search}`;
        window.history.replaceState(null, '', newUrl);

        setSelectedCoupon(null);
        setIsModalOpen(false);
    };

    return {
        selectedCoupon,
        isModalOpen,
        openCoupon,
        closeCoupon
    };
}
